<template>
	<div :class="{ hidden: hidden }" class="pagination-container" :style="{ 'text-align': align }">
		<el-pagination
			:current-page.sync="currentPage"
			:page-size.sync="pageSize"
			:total="total"
			:page-sizes="pageSizes"
			:background="background"
			:small="small"
			:layout="layout"
			v-bind="$attrs"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
		></el-pagination>
	</div>
</template>

<script>
	import { scrollTo } from '@/utils/scroll-to'

	export default {
		name: 'JrPagination',
		props: {
			limit: {
				type: Number,
				default: 10
			},
			page: {
				type: Number,
				default: 1
			},
			total: {
				required: true,
				type: Number
			},
			pageSizes: {
				type: Array,
				default() {
					return [10, 20, 30, 50]
				}
			},
			background: {
				type: Boolean,
				default: true
			},
			autoScroll: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			layout: {
				type: String,
				default: 'total, sizes, prev, pager, next, jumper'
			},
			align: {
				type: String,
				default: 'center'
			},
			hidden: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			currentPage: {
				get() {
					return this.page
				},
				set(val) {
					this.$emit('update:page', val)
				}
			},
			pageSize: {
				get() {
					return this.limit
				},
				set(val) {
					this.$emit('update:limit', val)
				}
			}
		},
		methods: {
			// 切换每页显示条数
			handleSizeChange(val) {
				this.$emit('change', { page: this.currentPage, limit: val })
				if (this.autoScroll) {
					scrollTo(0, 800)
				}
			},

			// 切换页码
			handleCurrentChange(val) {
				this.$emit('change', { page: val, limit: this.pageSize })
				if (this.autoScroll) {
					scrollTo(0, 800)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.pagination-container {
		text-align: center;
		padding: 15px 16px;

		::v-deep {
			.el-pagination.is-background .btn-next,
			.el-pagination.is-background .btn-prev,
			.el-pagination.is-background .el-pager li {
				min-width: 40px;
				height: 40px;
				line-height: 40px;
				background-color: #ffffff;
				border: 1px solid #e2e6e8;
				font-size: 16px;
			}

			.el-pagination.is-background .el-pager li:not(.disabled).active {
				background-color: #236fca;
				color: #ffffff;
			}

			.el-pagination button,
			.el-pagination span:not([class*='suffix']) {
				min-width: 40px;
				height: 40px;
				line-height: 40px;
				padding: 0 10px;
				font-size: 16px;
			}
		}
	}

	.pagination-container.hidden {
		display: none;
	}
</style>
